const BASE_URL = "https://integrationapi.evervent.in/api/";

export const URL_CONSTANTS = {
  SUBMIT_REQUEST: `${BASE_URL}health-insurances/set-subscriptions-email.json`,
  ENQUIRY_REQUEST: `${BASE_URL}users/sent-enquiry.json`,
};